export enum PARTNERS_UUID {
  OUR_MONEY_MARKET = 'e103b72a-be94-4aff-8e97-e23f9b08c7d3',
  CLEAR_SCORE = '90533b41-57c5-4f24-a65e-de078e3605a7',
  TRADE_ME = 'a2c53d48-5fe5-41aa-b6af-83194c158326',
  WISR = '0b17bc2a-1553-45d5-9eca-15b961c95c39',
  TESLA = '76a47e37-9cb2-47fc-bfbc-8bf2f9d96ecc',
  TESLA_GFV = '35da49fe-c717-4eb3-8c8c-ca0bc294dcc7',
  TESLA_UK = 'd3cc64a2-025e-4e1b-8e19-60e274b3674a',
}
